import { DIV, IMG } from 'sdi/components/elements';
import { getHarvesting } from 'view/src/queries/harvest';

export const render = () =>
    getHarvesting().map(({ minimap }) => {
        switch (minimap.step) {
            case 'loading':
                return DIV(
                    { className: 'field__value field--read' },
                    DIV({ className: '_loader' }, '~loading'),
                );
            case 'failed':
                return DIV(
                    { className: 'field__value field--read' },
                    DIV({ className: '_failed' }, '~failed'),
                );
            case 'loaded':
                return DIV(
                    { className: 'field__value field--read' },
                    IMG({ src: minimap.data, alt: '' }),
                );
        }
    });

export default render;
